import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import fetchMerchandiseTopCategories from 'actions/merchandise/fetchMerchandiseTopCategories'
import useMerchandiseCategories from './useMerchandiseCategories'

type ReturnType = [
  Array<App.MerchandiseCategory>,
  boolean,
  string | undefined,
]

function useMerchandiseTopCategories(): ReturnType {
  const dispatch = useAppDispatch()
  const topCategoriesState = useAppSelector(state => state.merchandise.merchandiseTopCategories)
  const [topCategories, fetchingCategories] = useMerchandiseCategories({
    categoryIds: topCategoriesState?.categoryIds ?? [],
  })

  useEffect(() => {
    dispatch(fetchMerchandiseTopCategories())
  }, [dispatch])

  return [
    topCategories,
    !!(topCategoriesState?.fetching || fetchingCategories),
    topCategoriesState?.error,
  ]
}

export default useMerchandiseTopCategories
